import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/modules/auth";
import { requestStatus, formatUserData } from "@/services/index";
import { getProfile } from "@/api/auth";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RouterWrapper"),
    children: [
      {
        path: "",
        name: "main_view",
        component: () =>
          import(/* webpackChunkName: "about" */ "../pages/MainPage/MainPage"),
      },
      {
        path: "reset-password",
        name: "reset-password",
        component: () =>
          import(/* webpackChunkName: "about" */ "../pages/ResetPasswordView"),
      },
      {
        path: "profile",
        name: "profile",
        component: () =>
          import(/* webpackChunkName: "about" */ "../pages/UserProfile.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: "/checkout-payment",
    name: "checkout",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/CheckoutPayments.vue"),
  },
  {
    path: "/refund-policy",
    name: "RefundPolicy",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/Policy/RefundPolicy"),
  },
  {
    path: "/terms-and-conditions",
    name: "terms-and-conditions",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../pages/Policy/TermsAndConditions"
      ),
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/Policy/PrivacyPolicy"),
  },
  {
    path: "/terms-of-purchase",
    name: "terms-of-purchase",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/Policy/TermsofPurchase"),
  },
  {
    path: "/membership",
    name: "membership",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/Policy/MembershipView"),
  },
  {
    path: "/membership-cancellation",
    name: "membership-cancellation",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../pages/Policy/MembershipCancellation"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const GoToNextPage = (profile, next, to) => {
  console.log(to);
  console.log(profile);
  next();
};

const setCurrentUser = (profile) => {
  store.mutations.set(store.state, {
    type: "currentUser",
    items: formatUserData(profile),
  });
};

router.beforeEach((to, from, next) => {
  let user = JSON.parse(localStorage.getItem("user"));

  if (
    to.name === "registration" &&
    store.state.currentUser &&
    !store.state.currentUser.is_temporary
  ) {
    next("/");
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!user?.token) {
      next("/");
      return;
    }

    if (!store.state.currentUser) {
      getProfile().then((response) => {
        if (response.status === requestStatus.success) {
          setCurrentUser(response.response.data);
          GoToNextPage(response.response.data, next, to);
        } else {
          if (
            response.status === requestStatus.logout ||
            response.status === requestStatus.error_connection ||
            response.status === requestStatus.error
          ) {
            localStorage.removeItem("user");
            setTimeout(() => {
              window.location.href = "/";
            }, 1500);
          }
        }
      });
    } else {
      GoToNextPage(store.state.currentUser, next, to);
    }
  } else {
    if (
      (!to.matched.some((record) => record.meta.requiresAuth) ||
        to.name == "main_view") &&
      user?.token
    ) {
      getProfile().then((response) => {
        if (response.status === requestStatus.success) {
          setCurrentUser(response.response.data);
        }
      });
    }
    next();
  }
});

export default router;
